module.exports = __webpack_public_path__ + "static/media/cat-space.ff9dd78e.svg";